export default {
  components: {},
  data() {
    return {
      showButton: true,
      showOptions: false,
    };
  },
  methods: {
    showOptionsButtons() {
      this.showButton = false;
      this.showOptions = true;
    },
    chooseOption(option) {
      console.log("Option chosen:", option);
    },
  },
};
